import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';

function Resoudre() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const isMobile = size.height > size.width;
  const mainStyle = { textAlign: 'left' };

  const handleWindowSizeChange = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull" style={mainStyle}>
            <h1>Resoudre un probleme</h1>
            <h3>Etape 1: Nature du probleme</h3>
            <p>Evaluer s'il s'agit d'un bogue technique ou d'une erreur d'utilisation</p>
            <h4>Bogue technique</h4>
            <p>Le client semble avoir utiliser le systeme correctement, mais il n'arrive pas a voir correctement tout le materiel</p> <a href="#bogue-technique">Details</a>
            <h4>Erreur d'utilisation</h4>
            <p>Le client sait qu'il a commis une erreur d'utilisation et souhaiterait corriger la situation. Dans ce cas, on supporte tout de meme, mais l'approche change.</p>
            <a href="#erreur-utilisation">Details</a>
            <a id="bogue-technique"><h3>Bogue technique</h3></a>
            <h4>1. Reproduire ce que voit le client</h4>
            <p>Si vous le pouvez, tentez de reproduire ce que voit le client.</p>
            <h3><a id="erreur-utilisation">Erreur d'utilisation</a></h3>
            <p>Cliquer ici pour se renre a <Link to="/Operations/Tutoriels">Tutoriels</Link></p>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Resoudre;



// WEBPACK FOOTER //
// src/components/Resoudre.js